import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { createStore } from 'zustand/vanilla';
import { useStore } from 'zustand';
import { HYDRATE_CONCURRENCY_BLOB, HYDRATE_CONCURRENCY_HTTP } from '../config';
import { isAbort, toPackError } from '../pack/errors';
import { clearGhToken, consumeDeclinedFlag, getGhToken } from '../app/gh-auth';
import { writeGhEntryParam } from '../app/resolve';
import { buildDetailVM, seedDetailHeader } from '../model/detail';
import { errorRow, parseFailureDetail, pendingRow } from '../model/parse';
import { consoleEntriesForStep, consoleHasStepTags, harHasStepTags, harLinesForStep } from '../model/issue-slice';
import { ArtifactUrlCache } from './artifact-urls';
import { createLocalPackClient } from './local-pack-client';
import { createHydrationScheduler } from './scheduler';

/** Why the Connect-GitHub gateway is showing (phase 'gh-auth'). */

/** Pack chooser (phase 'gh-choose'): an artifact/zip holds several
 * .evidence files — the user picks one. */

/** The dock's log streams and their pack sources. */

/** The Network tab's HAR — ALL attempts (logs/<n>-network.har) merged
 * into one view, matching how the Console/Terminal streams present a
 * single timeline (user decision 2026-07-09: no attempt switcher). */

/** One open test's detail page. Header is seeded synchronously from the
 * already-hydrated row (zero reads), then refined when the bundle lands. */

var idleLog = {
  phase: 'idle',
  lines: [],
  totalBytes: null
};
var idleHar = {
  phase: 'idle',
  har: null,
  totalBytes: null
};

/** The tests/-relative id all detail reads resolve against — the plain
 * slug for the final run, "<slug>/<n>" for an earlier attempt's mirror. */
export function detailReadId(detail) {
  return detail.attempt > 0 ? "".concat(detail.testId, "/").concat(detail.attempt) : detail.testId;
}

/** HAR entries from the logs/meta.yaml index, in attempt order. */
export function harRefsFor(detail) {
  return detail.logs.filter(function (l) {
    return l.format === 'har';
  }).map(function (l) {
    return "tests/".concat(detailReadId(detail), "/logs/").concat(l.file);
  }).sort();
}

/** The Issues tab's RCA drawer: one open issue, loaded from pack data. */

var initialState = {
  phase: 'landing',
  sourceLabel: null,
  sourceKind: null,
  sourceSize: null,
  header: null,
  rowIds: [],
  rows: new Map(),
  progress: {
    total: 0,
    done: 0,
    failed: 0
  },
  stats: null,
  attention: null,
  attentionPhase: 'loading',
  coverage: null,
  coveragePhase: 'loading',
  detail: null,
  issueDrawer: null,
  ghAuth: null,
  ghChoose: null,
  error: null
};
export var packStore = createStore(function () {
  return initialState;
});

// ---------------------------------------------------------------------------
// Non-reactive internals. The scheduler and client live outside the store;
// row patches are rAF-batched so hydration causes at most one store update
// (one list re-render) per frame no matter how fast rows land.
// ---------------------------------------------------------------------------

var client = null;
var scheduler = null;
var artifactUrls = null;
var unsubscribeStats = null;
/** Aborts an in-flight client.open() when the pack is switched/closed —
 * without it a superseded open keeps downloading in the background. */
var openController = null;
/** Aborts an in-flight detail bundle/log read when the detail closes or a
 * different test opens. */
var detailController = null;
/** Bumped on every open/close; stale async continuations check and bail. */
var generation = 0;
/** How the open pack arrived — powers the "Download evidence pack" action. */
var lastInput = null;
var pendingRowPatches = new Map();
var pendingProgress = null;
var pendingStats = null;
var flushScheduled = false;
var scheduleFlush = function scheduleFlush() {
  if (flushScheduled) return;
  flushScheduled = true;
  var run = function run() {
    flushScheduled = false;
    flush();
  };
  if (typeof requestAnimationFrame === 'function') {
    requestAnimationFrame(run);
  } else {
    setTimeout(run, 0);
  }
};
function flush() {
  var state = packStore.getState();
  var next = {};
  if (pendingRowPatches.size > 0) {
    var rows = new Map(state.rows);
    var _iterator = _createForOfIteratorHelper(pendingRowPatches),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray(_step.value, 2),
          id = _step$value[0],
          row = _step$value[1];
        rows.set(id, row);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    pendingRowPatches.clear();
    next.rows = rows;
  }
  if (pendingProgress) {
    next.progress = pendingProgress;
    pendingProgress = null;
  }
  if (pendingStats) {
    next.stats = pendingStats;
    pendingStats = null;
  }
  if (Object.keys(next).length > 0) packStore.setState(next);

  // Once every row settled, the flaky count is knowable — patch the header.
  // Only when NO row failed: an errored row's flakiness is unknowable, and
  // the tiles-honesty rule forbids asserting a definite count over unknowns
  // (the tile keeps its em-dash instead).
  var after = packStore.getState();
  if (after.phase === 'open' && after.header && after.header.flakyCount === null && after.progress.done >= after.progress.total && after.progress.failed === 0 && after.progress.total > 0) {
    var flaky = 0;
    var _iterator2 = _createForOfIteratorHelper(after.rows.values()),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _row = _step2.value;
        if (_row.state === 'loaded' && _row.flaky) flaky += 1;
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    packStore.setState({
      header: _objectSpread(_objectSpread({}, after.header), {}, {
        flakyCount: flaky
      })
    });
  }
}
var patchRow = function patchRow(id, row) {
  pendingRowPatches.set(id, row);
  scheduleFlush();
};
function teardown() {
  return _teardown.apply(this, arguments);
}
/**
 * Open a pack from a URL or File. Fully tears down any pack already open
 * (abort hydration, revoke object URLs, drop caches) so switching packs
 * cannot leak the previous pack's buffers.
 */
function _teardown() {
  _teardown = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var _openController, _detailController3, _scheduler2, _unsubscribeStats, _artifactUrls;
    var c;
    return _regeneratorRuntime.wrap(function (_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          (_openController = openController) === null || _openController === void 0 || _openController.abort();
          openController = null;
          (_detailController3 = detailController) === null || _detailController3 === void 0 || _detailController3.abort();
          detailController = null;
          (_scheduler2 = scheduler) === null || _scheduler2 === void 0 || _scheduler2.abort();
          scheduler = null;
          (_unsubscribeStats = unsubscribeStats) === null || _unsubscribeStats === void 0 || _unsubscribeStats();
          unsubscribeStats = null;
          (_artifactUrls = artifactUrls) === null || _artifactUrls === void 0 || _artifactUrls.releaseAll();
          artifactUrls = null;
          pendingRowPatches.clear();
          pendingProgress = null;
          pendingStats = null;
          c = client;
          client = null;
          if (!c) {
            _context3.next = 1;
            break;
          }
          _context3.next = 1;
          return c.close();
        case 1:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _teardown.apply(this, arguments);
}
export function openPack(_x) {
  return _openPack.apply(this, arguments);
}

/** Open a specific pack from the chooser (phase 'gh-choose'). Reflects the
 * pick in ?ghEntry= so a reload/copied link lands straight on it. */
function _openPack() {
  _openPack = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(input) {
    var gen, sourceLabel, c, controller, _yield$c$open, header, testIds, rows, _iterator3, _step3, id, s, _packErr$detail, packErr, _packErr$detail$entri, _packErr$detail2, _t2;
    return _regeneratorRuntime.wrap(function (_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          gen = ++generation;
          _context5.next = 1;
          return teardown();
        case 1:
          if (!(gen !== generation)) {
            _context5.next = 2;
            break;
          }
          return _context5.abrupt("return");
        case 2:
          sourceLabel = input.kind === 'file' ? input.file.name : input.kind === 'gh-artifact' ? "".concat(input.owner, "/").concat(input.repo, " \xB7 GitHub artifact ").concat(input.artifactId) : input.url;
          lastInput = input;

          // Connect-GitHub gate: without a token the fetch is a guaranteed 401 —
          // show the gateway instead of an error. Gated on the input KIND, so
          // host mounts passing SAS URLs (kaneai) can never land here.
          if (!(input.kind === 'gh-artifact' && !getGhToken())) {
            _context5.next = 3;
            break;
          }
          packStore.setState(_objectSpread(_objectSpread({}, initialState), {}, {
            phase: 'gh-auth',
            sourceLabel: sourceLabel,
            rows: new Map(),
            ghAuth: {
              ref: {
                owner: input.owner,
                repo: input.repo,
                artifactId: input.artifactId
              },
              reason: consumeDeclinedFlag() ? 'declined' : 'no-token'
            }
          }));
          return _context5.abrupt("return");
        case 3:
          packStore.setState(_objectSpread(_objectSpread({}, initialState), {}, {
            phase: 'loading',
            sourceLabel: sourceLabel,
            sourceKind: input.kind,
            sourceSize: input.kind === 'file' ? input.file.size : null,
            rows: new Map()
          }));
          c = createLocalPackClient();
          client = c;
          artifactUrls = new ArtifactUrlCache(c);
          controller = new AbortController();
          openController = controller;
          unsubscribeStats = c.onStats(function (s) {
            if (gen !== generation) return;
            pendingStats = s;
            scheduleFlush();
          });
          _context5.prev = 4;
          _context5.next = 5;
          return c.open(input, {
            signal: controller.signal
          });
        case 5:
          _yield$c$open = _context5.sent;
          header = _yield$c$open.header;
          testIds = _yield$c$open.testIds;
          if (!(gen !== generation)) {
            _context5.next = 6;
            break;
          }
          return _context5.abrupt("return");
        case 6:
          rows = new Map();
          _iterator3 = _createForOfIteratorHelper(testIds);
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              id = _step3.value;
              rows.set(id, pendingRow(id));
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
          packStore.setState({
            phase: 'open',
            header: header,
            rowIds: testIds,
            rows: rows,
            progress: {
              total: testIds.length,
              done: 0,
              failed: 0
            },
            stats: c.stats()
          });

          // Coverage loads non-blocking too — one read, ready-with-null when
          // the pack predates coverage (the tab renders an honest empty state).
          void c.readCoverage().then(function (coverage) {
            if (gen === generation) {
              packStore.setState({
                coverage: coverage,
                coveragePhase: 'ready'
              });
            }
          });

          // "Need your attention" loads non-blocking beside row hydration.
          // Two-phase: the index rows land after ONE read (phase flips to ready),
          // then the per-step records enrich them in place. A pack without a
          // failure index resolves to ready-with-null (honest empty state).
          void c.readAttention(function (provisional) {
            if (gen === generation) {
              packStore.setState({
                attention: provisional,
                attentionPhase: 'ready'
              });
            }
          }).then(function (attention) {
            if (gen === generation) {
              packStore.setState(attention ? {
                attention: attention,
                attentionPhase: 'ready'
              } : {
                attentionPhase: 'ready'
              });
            }
          });

          // A pack with zero tests is open and complete; show 0 flaky honestly.
          if (!(testIds.length === 0)) {
            _context5.next = 7;
            break;
          }
          packStore.setState({
            header: _objectSpread(_objectSpread({}, header), {}, {
              flakyCount: 0
            })
          });
          return _context5.abrupt("return");
        case 7:
          s = createHydrationScheduler({
            concurrency:
            // url streams over HTTP; file AND gh-artifact read from memory.
            input.kind === 'url' ? HYDRATE_CONCURRENCY_HTTP : HYDRATE_CONCURRENCY_BLOB,
            task: function () {
              var _task = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(id, signal) {
                var row, _t;
                return _regeneratorRuntime.wrap(function (_context4) {
                  while (1) switch (_context4.prev = _context4.next) {
                    case 0:
                      _context4.prev = 0;
                      _context4.next = 1;
                      return c.readTestRow(id, signal);
                    case 1:
                      row = _context4.sent;
                      if (gen === generation) patchRow(id, row);
                      _context4.next = 3;
                      break;
                    case 2:
                      _context4.prev = 2;
                      _t = _context4["catch"](0);
                      if (gen === generation && !isAbort(_t)) {
                        patchRow(id, errorRow(id, toPackError(_t, 'fetch-failed').message));
                      }
                      throw _t;
                    case 3:
                    case "end":
                      return _context4.stop();
                  }
                }, _callee4, null, [[0, 2]]);
              }));
              function task(_x5, _x6) {
                return _task.apply(this, arguments);
              }
              return task;
            }()
          });
          scheduler = s;
          s.onProgress(function (p) {
            if (gen !== generation) return;
            pendingProgress = p;
            scheduleFlush();
          });
          s.enqueue(testIds);
          _context5.next = 14;
          break;
        case 8:
          _context5.prev = 8;
          _t2 = _context5["catch"](4);
          if (!(gen !== generation || isAbort(_t2))) {
            _context5.next = 9;
            break;
          }
          return _context5.abrupt("return");
        case 9:
          _context5.next = 10;
          return teardown();
        case 10:
          if (!(gen !== generation)) {
            _context5.next = 11;
            break;
          }
          return _context5.abrupt("return");
        case 11:
          packErr = toPackError(_t2, 'fetch-failed'); // A 401 means the stored GitHub token is dead — purge it and show the
          // gateway ("session expired") instead of a terminal error.
          if (!(packErr.code === 'gh-auth-required' && input.kind === 'gh-artifact')) {
            _context5.next = 12;
            break;
          }
          clearGhToken();
          packStore.setState(_objectSpread(_objectSpread({}, initialState), {}, {
            phase: 'gh-auth',
            sourceLabel: sourceLabel,
            rows: new Map(),
            ghAuth: {
              ref: {
                owner: input.owner,
                repo: input.repo,
                artifactId: input.artifactId
              },
              reason: 'token-rejected'
            }
          }));
          return _context5.abrupt("return");
        case 12:
          if (!(packErr.code === 'gh-multiple-evidence-entries' && Array.isArray((_packErr$detail = packErr.detail) === null || _packErr$detail === void 0 ? void 0 : _packErr$detail.entries) && (input.kind === 'gh-artifact' || input.kind === 'file'))) {
            _context5.next = 13;
            break;
          }
          packStore.setState(_objectSpread(_objectSpread({}, initialState), {}, {
            phase: 'gh-choose',
            sourceLabel: sourceLabel,
            rows: new Map(),
            ghChoose: {
              input: input,
              entries: (_packErr$detail$entri = (_packErr$detail2 = packErr.detail) === null || _packErr$detail2 === void 0 ? void 0 : _packErr$detail2.entries) !== null && _packErr$detail$entri !== void 0 ? _packErr$detail$entri : []
            }
          }));
          return _context5.abrupt("return");
        case 13:
          packStore.setState({
            phase: 'error',
            error: packErr
          });
        case 14:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[4, 8]]);
  }));
  return _openPack.apply(this, arguments);
}
export function chooseGhEntry(entry) {
  var choose = packStore.getState().ghChoose;
  if (!choose) return;
  if (typeof document !== 'undefined') writeGhEntryParam(entry);
  void openPack(_objectSpread(_objectSpread({}, choose.input), {}, {
    entry: entry
  }));
}

/** Back to the landing screen, releasing everything the open pack held. */
export function closePack() {
  return _closePack.apply(this, arguments);
}

/** The virtualized list reports near-viewport ids; hydrate those first. */
function _closePack() {
  _closePack = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
    var _issueController3;
    return _regeneratorRuntime.wrap(function (_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          ++generation;
          lastInput = null;
          (_issueController3 = issueController) === null || _issueController3 === void 0 || _issueController3.abort();
          issueController = null;
          _context6.next = 1;
          return teardown();
        case 1:
          packStore.setState(_objectSpread(_objectSpread({}, initialState), {}, {
            rows: new Map()
          }));
        case 2:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _closePack.apply(this, arguments);
}
export function prioritizeRows(ids) {
  var _scheduler;
  (_scheduler = scheduler) === null || _scheduler === void 0 || _scheduler.prioritize(ids);
}

// ---------------------------------------------------------------------------
// Test-instance detail. Actions live here because `client` and `generation`
// are module-private; every async continuation is generation- AND
// controller-guarded (opening test B while A loads must drop A's result).
// ---------------------------------------------------------------------------

/**
 * Open one test's detail page. Paints synchronously from the hydrated row
 * (zero reads), then loads the bundle. Idempotent per test id.
 * `preferredStepId` (optional) selects that step instead of the first once
 * the tree lands — the RCA drawer's "View all steps" uses it to anchor on
 * the culprit.
 */
export function openTestDetail(id, preferredStepId) {
  var _state$detail, _state$detail2, _detailController, _state$header$started, _state$header;
  var attempt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var state = packStore.getState();
  if (state.phase !== 'open') return;
  if (((_state$detail = state.detail) === null || _state$detail === void 0 ? void 0 : _state$detail.testId) === id && state.detail.attempt === attempt) return;
  var c = client;
  if (!c) return;
  // Same test, different attempt: the folder scan is test-scoped — keep it.
  var priorRetryDirs = ((_state$detail2 = state.detail) === null || _state$detail2 === void 0 ? void 0 : _state$detail2.testId) === id ? state.detail.retryDirs : null;
  var gen = generation;
  (_detailController = detailController) === null || _detailController === void 0 || _detailController.abort();
  var controller = new AbortController();
  detailController = controller;
  packStore.setState({
    detail: {
      testId: id,
      attempt: attempt,
      retryDirs: priorRetryDirs,
      phase: 'loading',
      header: seedDetailHeader(id, state.rows.get(id), (_state$header$started = (_state$header = state.header) === null || _state$header === void 0 ? void 0 : _state$header.startedAt) !== null && _state$header$started !== void 0 ? _state$header$started : null),
      tree: null,
      logs: [],
      selectedStepKey: null,
      drawer: {
        open: false,
        tab: 'logs',
        logsSub: 'console'
      },
      console: idleLog,
      terminal: idleLog,
      appium: idleLog,
      network: idleHar,
      error: null
    }
  });

  // Central-directory-only scan for numeric attempt folders (one per test).
  if (priorRetryDirs === null) {
    void c.listDir("tests/".concat(id)).then(function (entries) {
      if (gen !== generation) return;
      var dirs = entries.filter(function (e) {
        return e.isDir && /^\d+$/.test(e.name);
      }).map(function (e) {
        return parseInt(e.name, 10);
      }).sort(function (a, b) {
        return a - b;
      });
      var current = packStore.getState().detail;
      if (!current || current.testId !== id) return;
      packStore.setState({
        detail: _objectSpread(_objectSpread({}, current), {}, {
          retryDirs: dirs
        })
      });
    })["catch"](function () {
      // Absence of the scan only means the switcher stays hidden.
      var current = packStore.getState().detail;
      if (gen !== generation || !current || current.testId !== id) return;
      packStore.setState({
        detail: _objectSpread(_objectSpread({}, current), {}, {
          retryDirs: []
        })
      });
    });
  }
  var readId = detailReadId({
    testId: id,
    attempt: attempt
  });
  void c.readTestDetail(readId, controller.signal, {
    skipSteps: true
  }).then(function (data) {
    var _packStore$getState$h, _packStore$getState$h2, _tree$flatSteps$find, _ref, _tree$flatSteps$;
    if (gen !== generation || detailController !== controller) return;
    var current = packStore.getState().detail;
    if (!current || current.testId !== id || current.attempt !== attempt) return;
    var _buildDetailVM = buildDetailVM(id, packStore.getState().rows.get(id), data, (_packStore$getState$h = (_packStore$getState$h2 = packStore.getState().header) === null || _packStore$getState$h2 === void 0 ? void 0 : _packStore$getState$h2.startedAt) !== null && _packStore$getState$h !== void 0 ? _packStore$getState$h : null),
      header = _buildDetailVM.header,
      tree = _buildDetailVM.tree;
    // User decision: the first step is the initial selection — unless the
    // caller anchored a specific step (RCA drawer's culprit jump).
    var preferred = preferredStepId ? (_tree$flatSteps$find = tree.flatSteps.find(function (s) {
      return s.id === preferredStepId || s.key === preferredStepId;
    })) === null || _tree$flatSteps$find === void 0 ? void 0 : _tree$flatSteps$find.key : undefined;
    packStore.setState({
      detail: _objectSpread(_objectSpread({}, current), {}, {
        phase: 'ready',
        header: header,
        tree: tree,
        logs: data.logs,
        selectedStepKey: (_ref = preferred !== null && preferred !== void 0 ? preferred : (_tree$flatSteps$ = tree.flatSteps[0]) === null || _tree$flatSteps$ === void 0 ? void 0 : _tree$flatSteps$.key) !== null && _ref !== void 0 ? _ref : null
      })
    });

    // The page is interactive now. Stream the per-step step.json (durations,
    // cursors, screenshot paths) and the objective outcomes in the
    // background and patch the already-rendered tree — no page-blocking
    // loader. Both are additive: either failing keeps what the other adds.
    void Promise.allSettled([c.readTestSteps(readId, controller.signal), c.readObjectiveOutcomes(readId, controller.signal)]).then(function (_ref2) {
      var _packStore$getState$h3, _packStore$getState$h4;
      var _ref3 = _slicedToArray(_ref2, 2),
        stepsRes = _ref3[0],
        outcomesRes = _ref3[1];
      if (gen !== generation || detailController !== controller) return;
      var bothFailed = stepsRes.status === 'rejected' && outcomesRes.status === 'rejected';
      if (bothFailed) {
        return;
      }
      var cur = packStore.getState().detail;
      if (!cur || cur.testId !== id || cur.attempt !== attempt) return;
      var enriched = buildDetailVM(id, packStore.getState().rows.get(id), _objectSpread(_objectSpread({}, data), {}, {
        steps: stepsRes.status === 'fulfilled' ? stepsRes.value : data.steps,
        objectiveOutcomes: outcomesRes.status === 'fulfilled' ? outcomesRes.value : []
      }), (_packStore$getState$h3 = (_packStore$getState$h4 = packStore.getState().header) === null || _packStore$getState$h4 === void 0 ? void 0 : _packStore$getState$h4.startedAt) !== null && _packStore$getState$h3 !== void 0 ? _packStore$getState$h3 : null);
      packStore.setState({
        detail: _objectSpread(_objectSpread({}, cur), {}, {
          header: enriched.header,
          tree: enriched.tree
        })
      });
    });
  })["catch"](function (e) {
    if (gen !== generation || detailController !== controller || isAbort(e)) {
      return;
    }
    var current = packStore.getState().detail;
    if (!current || current.testId !== id || current.attempt !== attempt) return;
    packStore.setState({
      detail: _objectSpread(_objectSpread({}, current), {}, {
        phase: 'error',
        error: toPackError(e, 'fetch-failed')
      })
    });
  });
}

/** Switch the open detail to another attempt of the SAME test (0 = final).
 * Full reload of the detail bundle; step selection resets to the first step. */
export function selectDetailAttempt(attempt) {
  var detail = packStore.getState().detail;
  if (!detail || detail.attempt === attempt) return;
  openTestDetail(detail.testId, undefined, attempt);
}

/** Back to the run view. */
export function closeTestDetail() {
  var _detailController2;
  (_detailController2 = detailController) === null || _detailController2 === void 0 || _detailController2.abort();
  detailController = null;
  if (packStore.getState().detail !== null) {
    packStore.setState({
      detail: null
    });
  }
}
var issueController = null;

/**
 * Open the RCA drawer for one failure-index row. Everything loads in
 * parallel and degrades independently — the drawer always reaches 'ready'
 * with whatever the pack actually carries (record, titled steps, log
 * slices, screenshot).
 */
export function openIssueDrawer(item) {
  var _issueController;
  var state = packStore.getState();
  if (state.phase !== 'open') return;
  var c = client;
  if (!c) return;
  var gen = generation;
  (_issueController = issueController) === null || _issueController === void 0 || _issueController.abort();
  var controller = new AbortController();
  issueController = controller;
  packStore.setState({
    issueDrawer: {
      item: item,
      phase: 'loading',
      record: null,
      steps: [],
      anchorKey: null,
      network: null,
      networkScope: null,
      console: null,
      consoleScope: null,
      screenshotPath: null
    }
  });
  var testBase = "tests/".concat(item.testId, "/");

  // The record first — its refs/cursor drive the log slices.
  var loadRecord = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var bytes;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (item.path) {
              _context.next = 1;
              break;
            }
            return _context.abrupt("return", null);
          case 1:
            _context.next = 2;
            return c.readBytes(item.path, controller.signal);
          case 2:
            bytes = _context.sent;
            if (!(bytes === null)) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return", null);
          case 3:
            return _context.abrupt("return", parseFailureDetail(new TextDecoder().decode(bytes)));
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function loadRecord() {
      return _ref4.apply(this, arguments);
    };
  }();
  void _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var _ref6, _record$step, _consoleRes$value, _harRes$value;
    var _yield$Promise$allSet, _yield$Promise$allSet2, recordRes, detailRes, record, steps, anchorKey, anchorId, _steps$find$key, _steps$find, _buildDetailVM2, tree, consolePath, networkPath, _yield$Promise$allSet3, _yield$Promise$allSet4, consoleRes, harRes, consoleEntries, consoleScope, _record$consoleRef$st, _record$consoleRef, cursor, network, networkScope, _record$networkRef$st, _record$networkRef, _cursor, current;
    return _regeneratorRuntime.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 1;
          return Promise.allSettled([loadRecord(), c.readTestDetail(item.testId, controller.signal)]);
        case 1:
          _yield$Promise$allSet = _context2.sent;
          _yield$Promise$allSet2 = _slicedToArray(_yield$Promise$allSet, 2);
          recordRes = _yield$Promise$allSet2[0];
          detailRes = _yield$Promise$allSet2[1];
          if (!(gen !== generation || issueController !== controller)) {
            _context2.next = 2;
            break;
          }
          return _context2.abrupt("return");
        case 2:
          record = recordRes.status === 'fulfilled' ? recordRes.value : null;
          steps = [];
          anchorKey = null;
          anchorId = (_ref6 = (_record$step = record === null || record === void 0 ? void 0 : record.step) !== null && _record$step !== void 0 ? _record$step : item.stepId) !== null && _ref6 !== void 0 ? _ref6 : null;
          if (detailRes.status === 'fulfilled') {
            _buildDetailVM2 = buildDetailVM(item.testId, packStore.getState().rows.get(item.testId), detailRes.value), tree = _buildDetailVM2.tree;
            steps = tree.flatSteps;
            anchorKey = (_steps$find$key = (_steps$find = steps.find(function (s) {
              return s.id === anchorId || s.key === anchorId;
            })) === null || _steps$find === void 0 ? void 0 : _steps$find.key) !== null && _steps$find$key !== void 0 ? _steps$find$key : null;
          }

          // Log slices: refs are test-dir-relative; cursor comes from the record.
          consolePath = record !== null && record !== void 0 && record.consoleRef ? testBase + record.consoleRef.ref : null;
          networkPath = record !== null && record !== void 0 && record.networkRef ? testBase + record.networkRef.ref : null;
          _context2.next = 3;
          return Promise.allSettled([consolePath ? c.readLogLines(consolePath, controller.signal) : Promise.resolve(null), networkPath ? c.readHar(networkPath, controller.signal) : Promise.resolve(null)]);
        case 3:
          _yield$Promise$allSet3 = _context2.sent;
          _yield$Promise$allSet4 = _slicedToArray(_yield$Promise$allSet3, 2);
          consoleRes = _yield$Promise$allSet4[0];
          harRes = _yield$Promise$allSet4[1];
          if (!(gen !== generation || issueController !== controller)) {
            _context2.next = 4;
            break;
          }
          return _context2.abrupt("return");
        case 4:
          // Strict step slice first. Fall back to ALL entries only when the log
          // carries NO step tags at all (legacy packs) — on tagged packs
          // (producer fix 2026-07-09) an empty strict slice means "genuinely
          // nothing captured at this step" and must render as an honest empty,
          // not as everything with a misleading label.
          consoleEntries = null;
          consoleScope = null;
          if (consoleRes.status === 'fulfilled' && ((_consoleRes$value = consoleRes.value) === null || _consoleRes$value === void 0 ? void 0 : _consoleRes$value.kind) === 'ready') {
            cursor = (_record$consoleRef$st = record === null || record === void 0 || (_record$consoleRef = record.consoleRef) === null || _record$consoleRef === void 0 ? void 0 : _record$consoleRef.step) !== null && _record$consoleRef$st !== void 0 ? _record$consoleRef$st : null;
            consoleEntries = consoleEntriesForStep(consoleRes.value.lines, cursor);
            consoleScope = 'step';
            if (consoleEntries.length === 0 && cursor !== null && !consoleHasStepTags(consoleRes.value.lines)) {
              consoleEntries = consoleEntriesForStep(consoleRes.value.lines, null);
              consoleScope = consoleEntries.length > 0 ? 'all' : 'step';
            }
          }
          network = null;
          networkScope = null;
          if (harRes.status === 'fulfilled' && ((_harRes$value = harRes.value) === null || _harRes$value === void 0 ? void 0 : _harRes$value.kind) === 'ready') {
            _cursor = (_record$networkRef$st = record === null || record === void 0 || (_record$networkRef = record.networkRef) === null || _record$networkRef === void 0 ? void 0 : _record$networkRef.step) !== null && _record$networkRef$st !== void 0 ? _record$networkRef$st : null;
            network = harLinesForStep(harRes.value.har, _cursor);
            networkScope = 'step';
            if (network.length === 0 && _cursor !== null && !harHasStepTags(harRes.value.har)) {
              network = harLinesForStep(harRes.value.har, null);
              networkScope = network.length > 0 ? 'all' : 'step';
            }
          }
          current = packStore.getState().issueDrawer;
          if (!(!current || current.item !== item)) {
            _context2.next = 5;
            break;
          }
          return _context2.abrupt("return");
        case 5:
          packStore.setState({
            issueDrawer: _objectSpread(_objectSpread({}, current), {}, {
              phase: 'ready',
              record: record,
              steps: steps,
              anchorKey: anchorKey,
              network: network,
              networkScope: networkScope,
              console: consoleEntries,
              consoleScope: consoleScope,
              screenshotPath: record !== null && record !== void 0 && record.screenshot ? testBase + record.screenshot : null
            })
          });
        case 6:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }))();
}
export function closeIssueDrawer() {
  var _issueController2;
  (_issueController2 = issueController) === null || _issueController2 === void 0 || _issueController2.abort();
  issueController = null;
  if (packStore.getState().issueDrawer !== null) {
    packStore.setState({
      issueDrawer: null
    });
  }
}
export function selectDetailStep(key) {
  var detail = packStore.getState().detail;
  if (!detail || detail.selectedStepKey === key) return;
  packStore.setState({
    detail: _objectSpread(_objectSpread({}, detail), {}, {
      selectedStepKey: key
    })
  });
}

/** Open/close the logs dock or switch tabs; first activation of the Logs
 * tab triggers the lazy console read (no log bytes move before that). */
export function setDetailDrawer(open, tab) {
  var detail = packStore.getState().detail;
  if (!detail) return;
  var nextTab = tab !== null && tab !== void 0 ? tab : detail.drawer.tab;
  packStore.setState({
    detail: _objectSpread(_objectSpread({}, detail), {}, {
      drawer: _objectSpread(_objectSpread({}, detail.drawer), {}, {
        open: open,
        tab: nextTab
      })
    })
  });
  if (open && nextTab === 'logs') {
    loadDetailLog(detail.drawer.logsSub);
  }
}

/** Switch the Logs tab's Console|Terminal sub-view (drives its lazy load).
 * Lives in the store so the command palette can target a specific stream. */
export function setDetailLogsSub(kind) {
  var detail = packStore.getState().detail;
  if (!detail) return;
  packStore.setState({
    detail: _objectSpread(_objectSpread({}, detail), {}, {
      drawer: _objectSpread(_objectSpread({}, detail.drawer), {}, {
        logsSub: kind
      })
    })
  });
  if (detail.drawer.open && detail.drawer.tab === 'logs') {
    loadDetailLog(kind);
  }
}

/** The pack's Appium server log entry (mobile runs author
 * appium-server-emulator.log / appium-server-simulator.log — match the
 * family, not one target). Null on web packs → the tab stays hidden. */
export function appiumLogRef(detail) {
  var _detail$logs$find;
  var ref = (_detail$logs$find = detail.logs.find(function (l) {
    return l.format === 'log' && /^appium/.test(l.name);
  })) !== null && _detail$logs$find !== void 0 ? _detail$logs$find : detail.logs.find(function (l) {
    return /^appium.*\.log$/.test(l.file);
  });
  return ref ? ref.file : null;
}

/** Resolve a log stream to its pack entry via the logs/meta.yaml index.
 * console → the *-console ndjson; terminal → the *-run runner log;
 * appium → the appium-server-*.log. */
function logRelFor(detail, kind) {
  var _detail$logs$find2, _detail$logs$find3;
  if (kind === 'appium') {
    var file = appiumLogRef(detail);
    return file ? "tests/".concat(detailReadId(detail), "/logs/").concat(file) : null;
  }
  var ref = kind === 'console' ? (_detail$logs$find2 = detail.logs.find(function (l) {
    return l.format === 'ndjson' && /(^|-)console$/.test(l.name);
  })) !== null && _detail$logs$find2 !== void 0 ? _detail$logs$find2 : detail.logs.find(function (l) {
    return /console/.test(l.file);
  }) : (_detail$logs$find3 = detail.logs.find(function (l) {
    return l.format === 'log' && /(^|-)run$/.test(l.name);
  })) !== null && _detail$logs$find3 !== void 0 ? _detail$logs$find3 : detail.logs.find(function (l) {
    return /(^|-)run\.log$/.test(l.file);
  });
  if (!ref) return null;
  return "tests/".concat(detailReadId(detail), "/logs/").concat(ref.file);
}

/**
 * Load the Network tab's HAR — EVERY attempt's file, merged into one
 * timeline (entries concatenated in attempt order = chronological;
 * pages likewise). Honest degradation: any too-large attempt keeps the
 * whole view behind the size guard (no silently-partial merge); all
 * missing → missing; parse failures with zero successes → invalid.
 * Idempotent; zero bytes move before the tab first asks.
 */
export function loadDetailHar() {
  var c = client;
  var detail = packStore.getState().detail;
  if (!c || !detail) return;
  var refs = harRefsFor(detail);
  var testId = detail.testId;
  var patch = function patch(state) {
    var current = packStore.getState().detail;
    if (!current || current.testId !== testId) return;
    packStore.setState({
      detail: _objectSpread(_objectSpread({}, current), {}, {
        network: state
      })
    });
  };
  if (refs.length === 0) {
    if (detail.network.phase === 'idle') {
      patch(_objectSpread(_objectSpread({}, idleHar), {}, {
        phase: 'missing'
      }));
    }
    return;
  }
  var network = detail.network;
  if (network.phase !== 'idle' && network.phase !== 'missing') {
    return; // already loaded/loading
  }
  var gen = generation;
  var controller = detailController;
  patch({
    phase: 'loading',
    har: null,
    totalBytes: null
  });
  void Promise.allSettled(refs.map(function (ref) {
    return c.readHar(ref, controller === null || controller === void 0 ? void 0 : controller.signal);
  })).then(function (results) {
    if (gen !== generation || detailController !== controller) return;
    if (results.some(function (r) {
      return r.status === 'rejected' && isAbort(r.reason);
    })) {
      return;
    }
    var values = results.map(function (r) {
      return r.status === 'fulfilled' ? r.value : null;
    });
    var tooLarge = values.find(function (v) {
      return (v === null || v === void 0 ? void 0 : v.kind) === 'too-large';
    });
    if (tooLarge && tooLarge.kind === 'too-large') {
      patch({
        phase: 'too-large',
        har: null,
        totalBytes: tooLarge.totalBytes
      });
      return;
    }
    var ready = values.filter(function (v) {
      return (v === null || v === void 0 ? void 0 : v.kind) === 'ready';
    });
    if (ready.length === 0) {
      var anyInvalid = values.some(function (v) {
        return (v === null || v === void 0 ? void 0 : v.kind) === 'invalid';
      });
      var anyError = results.some(function (r) {
        return r.status === 'rejected';
      });
      patch({
        phase: anyInvalid ? 'invalid' : anyError ? 'error' : 'missing',
        har: null,
        totalBytes: null
      });
      return;
    }
    var logs = ready.map(function (r) {
      var _r$har$log;
      return (_r$har$log = r.har.log) !== null && _r$har$log !== void 0 ? _r$har$log : {};
    });
    var merged = _objectSpread(_objectSpread({}, ready[0].har), {}, {
      log: _objectSpread(_objectSpread({}, logs[0]), {}, {
        pages: logs.flatMap(function (l) {
          return Array.isArray(l.pages) ? l.pages : [];
        }),
        entries: logs.flatMap(function (l) {
          return Array.isArray(l.entries) ? l.entries : [];
        })
      })
    });
    patch({
      phase: 'ready',
      har: merged,
      totalBytes: ready.reduce(function (a, r) {
        var _r$totalBytes;
        return a + ((_r$totalBytes = r.totalBytes) !== null && _r$totalBytes !== void 0 ? _r$totalBytes : 0);
      }, 0)
    });
  })["catch"](function (e) {
    if (gen !== generation || detailController !== controller || isAbort(e)) {
      return;
    }
    patch({
      phase: 'error',
      har: null,
      totalBytes: null
    });
  });
}

/** Lazily load one of the dock's log streams (idempotent per stream). */
export function loadDetailLog(kind) {
  var c = client;
  var detail = packStore.getState().detail;
  if (!c || !detail || detail[kind].phase !== 'idle') return;
  var testId = detail.testId;
  var patch = function patch(state) {
    var current = packStore.getState().detail;
    if (!current || current.testId !== testId) return;
    packStore.setState({
      detail: _objectSpread(_objectSpread({}, current), {}, _defineProperty({}, kind, state))
    });
  };
  var rel = logRelFor(detail, kind);
  if (rel === null) {
    patch({
      phase: 'missing',
      lines: [],
      totalBytes: null
    });
    return;
  }
  var gen = generation;
  var controller = detailController;
  patch({
    phase: 'loading',
    lines: [],
    totalBytes: null
  });
  void c.readLogLines(rel, controller === null || controller === void 0 ? void 0 : controller.signal).then(function (result) {
    if (gen !== generation || detailController !== controller) return;
    if (result === null) {
      patch({
        phase: 'missing',
        lines: [],
        totalBytes: null
      });
    } else if (result.kind === 'too-large') {
      patch({
        phase: 'too-large',
        lines: [],
        totalBytes: result.totalBytes
      });
    } else {
      patch({
        phase: 'ready',
        lines: result.lines,
        totalBytes: result.totalBytes
      });
    }
  })["catch"](function (e) {
    if (gen !== generation || detailController !== controller || isAbort(e)) {
      return;
    }
    patch({
      phase: 'error',
      lines: [],
      totalBytes: null
    });
  });
}

/** Object URL for an artifact entry (screenshots later) — cache owns revocation. */
export function artifactUrlCache() {
  return artifactUrls;
}

/** Raw bytes of one pack entry (coverage source downloads), or null when
 * absent / nothing open. LRU-cached by the client. */
/** A test's dataset row values (execution.json test_params), on demand.
 * [] when the pack is closed or the file is unreadable. */
export function readDatasetParams(_x2) {
  return _readDatasetParams.apply(this, arguments);
}
function _readDatasetParams() {
  _readDatasetParams = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(testId) {
    var _t3;
    return _regeneratorRuntime.wrap(function (_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          if (client) {
            _context7.next = 1;
            break;
          }
          return _context7.abrupt("return", []);
        case 1:
          _context7.prev = 1;
          _context7.next = 2;
          return client.readDatasetParams(testId);
        case 2:
          return _context7.abrupt("return", _context7.sent);
        case 3:
          _context7.prev = 3;
          _t3 = _context7["catch"](1);
          return _context7.abrupt("return", []);
        case 4:
        case "end":
          return _context7.stop();
      }
    }, _callee7, null, [[1, 3]]);
  }));
  return _readDatasetParams.apply(this, arguments);
}
export function readPackBytes(_x3) {
  return _readPackBytes.apply(this, arguments);
}

/* ── INTERNAL pack explorer (localStorage-gated debug surface) ── */

/** Every raw entry in the open pack (name + uncompressed size), or null
 * when nothing is open. */
function _readPackBytes() {
  _readPackBytes = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8(rel) {
    return _regeneratorRuntime.wrap(function (_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          if (!(packStore.getState().phase !== 'open' || !client)) {
            _context8.next = 1;
            break;
          }
          return _context8.abrupt("return", null);
        case 1:
          return _context8.abrupt("return", client.readBytes(rel));
        case 2:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return _readPackBytes.apply(this, arguments);
}
export function explorerListEntries() {
  return _explorerListEntries.apply(this, arguments);
}

/** Raw bytes of one pack entry for the explorer viewer (LRU-cached by
 * the client), or null when absent / nothing open. */
function _explorerListEntries() {
  _explorerListEntries = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
    return _regeneratorRuntime.wrap(function (_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          if (!(packStore.getState().phase !== 'open' || !client)) {
            _context9.next = 1;
            break;
          }
          return _context9.abrupt("return", null);
        case 1:
          return _context9.abrupt("return", client.listEntries());
        case 2:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return _explorerListEntries.apply(this, arguments);
}
export function explorerReadBytes(_x4) {
  return _explorerReadBytes.apply(this, arguments);
}

/** Trigger a browser download of `href` under `name` (blob:/same-origin
 * hrefs honor the attribute). */
function _explorerReadBytes() {
  _explorerReadBytes = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee0(rel) {
    return _regeneratorRuntime.wrap(function (_context0) {
      while (1) switch (_context0.prev = _context0.next) {
        case 0:
          if (!(packStore.getState().phase !== 'open' || !client)) {
            _context0.next = 1;
            break;
          }
          return _context0.abrupt("return", null);
        case 1:
          return _context0.abrupt("return", client.readBytes(rel));
        case 2:
        case "end":
          return _context0.stop();
      }
    }, _callee0);
  }));
  return _explorerReadBytes.apply(this, arguments);
}
function clickDownloadAnchor(href, name) {
  var a = document.createElement('a');
  a.href = href;
  a.download = name;
  a.rel = 'noopener';
  a.click();
}

/**
 * Download the open pack as a .evidence file. File-opened packs download
 * their own Blob. URL-opened packs are fetched into a Blob first: the
 * `download` attribute is IGNORED on cross-origin URLs, so navigating to
 * the source directly lets the host's Content-Disposition/Content-Type
 * pick the filename — artifact hosts stamp `application/zip` (a pack IS
 * a zip container) and the save lands as `<uuid>.zip` (TE-27235). A
 * blob: URL always honors our name, and CORS already permits the fetch
 * (the reader streams this same URL with Range requests). Falls back to
 * the direct anchor if the fetch fails, i.e. worst case is the old
 * behavior. No-op when nothing is open.
 */
export function downloadPack() {
  if (!lastInput || typeof document === 'undefined') return;
  if (lastInput.kind === 'gh-artifact') {
    var _client;
    // The client extracted the inner .evidence at open — no refetch,
    // and the saved name is the real entry name.
    void ((_client = client) === null || _client === void 0 ? void 0 : _client.packFile().then(function (f) {
      if (!f) return;
      var url = URL.createObjectURL(f.blob);
      clickDownloadAnchor(url, f.name || 'pack.evidence');
      setTimeout(function () {
        return URL.revokeObjectURL(url);
      }, 10000);
    }));
    return;
  }
  if (lastInput.kind === 'file') {
    var url = URL.createObjectURL(lastInput.file);
    clickDownloadAnchor(url, lastInput.file.name || 'pack.evidence');
    // Give the click a beat before revoking.
    setTimeout(function () {
      return URL.revokeObjectURL(url);
    }, 10000);
    return;
  }
  var sourceUrl = lastInput.url;
  var base = decodeURIComponent(sourceUrl.split('?')[0].split('/').pop() || '');
  // `<stem>.evidence` even when the host's basename says `.zip` or is a
  // bare uuid; only an empty basename falls back to the generic name.
  var stem = base.replace(/\.(evidence|zip)$/i, '');
  var name = "".concat(stem || 'pack', ".evidence");
  fetch(sourceUrl).then(function (res) {
    if (!res.ok) throw new Error("pack fetch failed: HTTP ".concat(res.status));
    return res.blob();
  }).then(function (blob) {
    var url = URL.createObjectURL(blob);
    clickDownloadAnchor(url, name);
    setTimeout(function () {
      return URL.revokeObjectURL(url);
    }, 10000);
  })["catch"](function () {
    return clickDownloadAnchor(sourceUrl, name);
  });
}

// ---------------------------------------------------------------------------
// React bindings
// ---------------------------------------------------------------------------

export function usePackState(selector) {
  return useStore(packStore, selector);
}
export function useTestRow(id) {
  return useStore(packStore, function (s) {
    return s.rows.get(id);
  });
}